module.exports = __webpack_public_path__ + "dfec7afc899eea9e7c68cecc31cd07f4.pdf";